import { Box, Button } from "@mui/material";
import { VM_Colors } from "../Styles/VMStyles";
import { STATUS_COMPLETED, STATUS_INCOMPLETED, STATUS_INPROGRESS, STATUS_PENDING } from "../Util/VMConstants";

function StatusButton({ status, handleUpdateStatus, justify = "center" }) {
  let color = '';
  let noHover = false;

  switch (status?.toLowerCase()) {
    case 'lead':
      color = VM_Colors.lead;
      noHover = true;
      break;
    case 'confirmed':
    case STATUS_COMPLETED.toLowerCase():
      color = VM_Colors.success;
      noHover = true;
      break;
    case 'not interested':
    case 'not-interested':  
    case STATUS_INCOMPLETED.toLowerCase():   
    case STATUS_PENDING.toLowerCase():
      color = VM_Colors.error;
      noHover = true;
      break;
    case STATUS_INPROGRESS.toLowerCase() :  
      color = VM_Colors.secondary;
      noHover = true;
      break;
    default:
      color = VM_Colors.black; // Provide fallback color
  }

  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: justify === "left" ? "flex-start" : "center",
      }}
    >
      <Button
        variant="contained"
        size="small"
        onClick={handleUpdateStatus}
        sx={{
          minWidth: 112,
          height: 30,
          px: 1.25,
          borderRadius: 1,
          fontSize: "0.82rem",
          fontWeight: 600,
          lineHeight: 1,
          whiteSpace: "nowrap",
          textAlign: "center",
          backgroundColor: color,
          boxShadow: "none",
          "&:hover": {
            backgroundColor: noHover ? color : undefined,
            boxShadow: "none",
          },
        }}
      >
        {status}
      </Button>
    </Box>
  );
}

export default StatusButton;
